var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"va-simple-palette-picker"},[_c('ul',{staticClass:"va-simple-palette-picker__colors"},_vm._l((_vm.palette),function(color,index){return _c('color-dot',{key:index,attrs:{"color":color,"selected":_vm.isSelected(color)},nativeOn:{"click":function($event){return _vm.handlerClick(color)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }